<template>
    <v-dialog  persistent  v-model="dialog" width="500px">      
      <v-card >
        <v-card-title :class="`white--text ${typeColorType}`" >
            <label>Event info</label>
            <v-spacer></v-spacer>            
            <v-icon dark class="fas fa-times" style="color:#fff" @click="closeClicked()"></v-icon>                  
        </v-card-title>       
        <v-card-text class="grey lighten-4"  >
            <v-layout   class="layout px-0 py-0" wrap row>                
                <v-flex sm6>
                    <div class="text-xs-center">
                        <h5>Type</h5>
                        <h4>{{event.eventType.name}}</h4>
                    </div>
                </v-flex>  
                <v-flex sm6>
                    <div class="text-xs-center">
                        <h5>{{dossierItem.timestamp | date_nl}}</h5>
                        <h4>{{dossierItem.timestamp | time}}</h4>                        
                    </div>
                </v-flex>                      
            </v-layout>            
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text  >
            <v-layout   class="layout px-2 py-0" wrap row align-center>                
                <v-flex sm12 align-center >                     
                    <template v-if="event.eventActions">
                        <template  v-if="dossierItem.data.discardedAt">
                            <i class="fas fa-check-circle green--text event-status-type-icon pr-2"></i> Dit event is automatisch behandeld door een actie
                        </template>
                        <template  v-else>
                            <i class="fas fa-link black--text event-status-type-icon pr-2"></i> Dit event is gekoppeld aan een actie
                        </template>
                    </template>
                    <template v-else-if="discarded">                                
                        <template v-if="dossierItem.data.discardedAt">
                            <i class="fas fa-check-circle green--text event-status-type-icon pr-2"  ></i> Dit event is afgehandeld op {{dossierItem.data.discardedAt | date_time_nl}}                                                                                                    
                        </template>
                        <template v-else="dossierItem.data.discardedAt">
                            <i class="fas fa-exclamation pr-2 red--text" ></i>Dit event moet worden afgehandeld                            
                        </template>
                    </template>
                    <div v-else> Geen bijzonderheden </div>
                    <!-- <v-icon color="green">check_circle</v-icon> Event is afgehandeld -->
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-divider></v-divider>
            <v-card-text>
                <v-layout   class="layout px-2 py-0" wrap row align-center>                
                    <v-flex sm12 align-center>
                        <h5 class="grey--text">Event</h5>{{event.name}}
                    </v-flex>
                    <v-flex sm12 align-center>
                        <h5 class="grey--text">Datum</h5>{{event.timestamp | date_nl}} om {{event.timestamp | time}}
                    </v-flex>
                    <v-flex sm12 align-center>
                        <h5 class="grey--text">Omschrijving</h5>{{event.shortText}}
                    </v-flex>
                </v-layout>
            </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-btn color="darken-1" flat @click="$emit('closeClicked')">Sluiten</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" flat @click="discardEvent()" v-if="discardable && !discarded">Event afgehandeld</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as types from "../../store/types"
import ColorMixin from "../../plugins/mixins/ColorMixin"

export default{    
    props:['dossierItem', 'asset'],
    mixins: [ColorMixin],
    data(){
        return {
            dialog: true,
            comments: ''
        }
    },
    computed:{
        severityColor(){
              switch(this.event.eventSeverity.internalName) {
                case 'irrelevant':
                    return "grey"
                case 'low':
                    return "grey";
                case 'average':
                    return "orange";
                case 'high':
                    return "red";
                case 'critical':
                    return "red";
                default :
                return 'grey';
            }
        },
        event(){
            return this.dossierItem.event
        },
        typeColorType(){            
            switch(this.event.eventType.internalName) {
                case 'success':
                    return "success"
                case 'error':
                    return "error";
                case 'info':
                    return "info";
                case 'warning':
                    return "warning";
                default :
                return 'grey';
            }
        },
        discarded(){
            return (this.dossierItem.data && this.dossierItem.data.discardedAt) ? true : false
                
        },
         discardable(){      

            if(this.event.eventType.internalName == 'error'){
                if(this.event.eventSeverity.priority >= 3){
                    return true
                }                
            }
            if(this.event.eventType.internalName == 'warning'){
                if(this.event.eventSeverity.priority >= 5){
                    return true
                }
            }
            },
    },
    methods:{        
        discardEvent(){
            let vm = this
            this.$store.dispatch(types.DISCARD_PROCESSED_EVENT, { data: { id: this.dossierItem.id }}).then(() => {                
                vm.$notify("Event afgehandeld", {type: 'success', icon: 'check'})
                vm.$emit("EventDiscarded")
            })
        },
        closeClicked(){
            this.$emit("closeClicked")
        }        
    },

    mounted(){
    }
}
</script>
